module.exports = __webpack_public_path__ + "static/media/DsmIcon.dd850e01.svg";